module.exports = __webpack_public_path__ + "img/member_rights_icon_431008.3016ae8a.png";